import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

export const thingApiSlice = createApi({
    reducerPath: 'thingApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    tagTypes: ['getDeviceState'],
    endpoints: (builder) => ({
        getDeviceState: builder.mutation({
            query: ({ 
                deviceName,
            }: {
                deviceName: string;
            }) => ({
                url: `/device/status/${deviceName}`,
                method: 'GET',
            }),
            invalidatesTags: ['getDeviceState'],
        }),
    }),
});

export const { 
    useGetDeviceStateMutation, 
} = thingApiSlice;
